import React from "react";

const AboutMilesEducationMobile = () => {
  return (
    <>
      {/* //  mobile version */}
      <div className="flex w-full justify-center py-10 bg-[#5BB3FF] md:hidden ">
        <div className="bg-[#F4F4F4] w-full max-w-[350px] px-4 py-6 rounded-[16px] shadow-lg">
          <div className="w-full text-center mb-4">
            <h2 className="text-[24px] font-semibold text-[#1D1D1D] leading-normal tracking-[-0.96px]">
              <span className="border-[#ca7216] border-b-2">
                About Miles Education
              </span>
            </h2>
          </div>

          <div className="w-full flex justify-center mb-4">
            <img
              src="/about-us/vj.webp"
              alt="Miles Education"
              className="rounded-[16px] w-[290px] h-[220px] object-cover"
            />
          </div>

          <div className="text-center">
            <p className="text-[#5C5C5C] mb-4 text-[16px] leading-[24px] tracking-[-0.64px] font-medium">
              The global talent landscape has critical gaps, but at Miles
              Education, we’re not just filling these voids—we’re building{" "}
              <span className="font-bold">pathways to success</span>. Driven by
              our mission to work backward from industry shortages, skill gaps,
              and opportunities, we empower businesses and enable talent by
              combining academic learning with hands-on experience through{" "}
              <span className="font-bold">our unique ED-WORK Pedagogy</span> .
              This approach equips students with practical skills and real-world
              insights as we address shortages across{" "}
              <span className="font-bold">
                accounting, healthcare, business, and technology.
              </span>
            </p>
            <h3 className="text-[20px] font-bold text-[#1D1D1D] mb-2 leading-[146%] tracking-[-0.8px]">
              Outcomes First:
            </h3>
            <p className="text-[16px] font-medium text-[#5C5C5C] leading-[24px] tracking-[-0.64px]">
              We don’t believe in cookie-cutter education. We start by analyzing
              industry needs, then meticulously craft{" "}
              <span className="font-bold">
                transformative learning pathways
              </span>{" "}
              that prime talent for success.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutMilesEducationMobile;
